import { readContract, writeContractAndWait } from "../viem";

import OgCrateABI from "../../abis/OGCrate(ERC1155).json";

import config from "../../config/config";

const address = config.ogCrateAddress;
const abi = OgCrateABI;

export const crateBalanceOf = async (account: string) => {
  const crateBalance: number = await readContract({
    address,
    abi,
    functionName: "balanceOf",
    args: [account, 0],
  });

  return crateBalance;
};

export const isCrateApprovedForAll = async (
  account: string,
  spender: string
) => {
  const isApproved: boolean = await readContract({
    address,
    abi,
    functionName: "isApprovedForAll",
    args: [account, spender],
  });

  return isApproved;
};

export const setCrateApprovalForAll = async (
  operator: string,
  approved: boolean,
  account: string
) => {
  await writeContractAndWait({
    address,
    abi,
    functionName: "setApprovalForAll",
    args: [operator, approved],
    account,
  });
};
